import { render, staticRenderFns } from "./VideoBrightcove.vue?vue&type=template&id=9ae103a8&"
import script from "./VideoBrightcove.vue?vue&type=script&lang=js&"
export * from "./VideoBrightcove.vue?vue&type=script&lang=js&"
import style0 from "./VideoBrightcove.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports